import router from '@/router'

export default () => {
  router.addRoute({
    path: '/sage-auth',
    name: 'sage-auth',
    component: () => import('./Auth.vue'),
    meta: {
      // This route should be accessible without authentication
      public: true
    }
  })
}
